<template>
    <el-scrollbar style="height: 100%;" wrap-class="scrollbar-wrapper">
        <el-menu :background-color="menubackgroundcolor"
                 text-color="#fff"
                 active-text-color="#262626"
                 :default-active="activeMenu"
                 class="el-menu-vertical-demo"
                 :collapse="isCollapse"
                 :unique-opened="true">
            <!--<i class="el-icon-menu" style="padding: 16px 20px;font-size: 24px; " @click="handleMenu"></i>-->
            <sub-menu :tag="tag" :pid="pid" :sub-menu-list="permission_routes"></sub-menu>
        </el-menu>
    </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SubMenu from '@/components/aside/SubMenu'
export default {
    name: "MyAside",
    components: {SubMenu},
    props: {
        tag:{
            type: String,
            default: '0'
        },
        pid:{
            type: Number,
            default: null
        }
    },
    data () {
        return {
            menubackgroundcolor: '#2C3650',
            // menu: this.$store.state.menus
        }
    },
    methods: {
        handleMenu () {
            this.sidebar.opened = !this.sidebar.opened
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
    },
    computed: {
        ...mapGetters([
            'permission_routes',
            'project_routes',
            'sidebar'
        ]),
        noChildren () {
            let routes = []
            /*if(this.tag==='1'){
                routes = this.project_routes.filter((item) => !item.children)
            }else{
                routes = this.permission_routes.filter((item) => !item.children)
            }*/
            routes = this.permission_routes.filter((item) => !item.children)
            return routes
        },
        hasChildren () {
            let routes = []
            /*if(this.tag==='1'){
                routes = this.project_routes.filter((item) => item.children)
            }else{
                routes = this.permission_routes.filter((item) => item.children)
            }*/
            routes = this.permission_routes.filter((item) => item.children)
            return routes
        },
        isCollapse () {
            return !this.sidebar.opened
            // this.$store.state.isCollapse
        },
        activeMenu() {
            const route = this.$route
            // console.log(route)
            const { meta, path } = route
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        }
    }
}
</script>

<style lang="scss" >
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 240px;
        min-height: 400px;
    }
    .el-menu-vertical-demo {
        height: 100%
    }
    .el-menu-item.is-active{
        background-color: #FFDA4B!important;
    }
    ::v-deep .el-menu{
        border-right: solid 0px #e6e6e6;
    }
    .scrollbar-wrapper{
        overflow-x: hidden !important;
    }
    .el-scrollbar__bar.is-vertical {
        right: 0px;
    }
    .el-scrollbar__view{
        height: inherit;
    }
</style>
